import { css } from "linaria";

export const cabinetParticularityGrid = css`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: 379px 379px;
  gap: 32px 24px;

  @media (--only-desktop) {
    grid-template-rows: 462px 462px;
  }

  @media (--only-tablet) {
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: 421px 421px 421px;
  }

  @media (--only-mobile) {
    grid-template-columns: 1fr;
    grid-template-rows: repeat(6, 325px);
  }
`;

export const cabinetParticularityCardOpen = css`
  transform: rotateY(180deg);
`;

export const cabinetParticularityCard = css`
  cursor: pointer;
  position: relative;
  background-color: var(--background-secondary);
  border-radius: var(--rounding-l);
  width: 100%;
  height: 100%;
  transition: transform 1s;
  transform-style: preserve-3d;
  perspective: 1000px;
`;

export const cabinetParticularityFlipCardBack = css`
  transform: rotateY(180deg);
`;

export const cabinetParticularityFlipCard = css`
  padding: 24px;
  position: absolute;
  width: 100%;
  height: 100%;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
`;

export const cabinetParticularityCardTitle = css`
  white-space: break-spaces;
  margin-bottom: 16px;
`;

export const cabinetParticularityCardImage = css`
  position: absolute;
  bottom: 0;
  right: 0;

  @media (--only-largeDesktop) {
    width: 250px;
    height: 230px;
  }
`;

export const cabinetParticularityCardIcon = css`
  position: absolute;
  bottom: 24px;
  left: 20px;

  @media (--only-mobile) {
    width: 40px;
    height: 40px;
  }
`;
